module.exports = __webpack_public_path__ + "asset/contract-form--f1def4.png";